import { useStore } from '@nanostores/react'
import styled from 'styled-components'
import { GitHub } from '../../icons/GitHub'
import { Link } from '../../icons/Link'
import { Redo } from '../../icons/Redo'
import { Undo } from '../../icons/Undo'
import { selectedStore } from '../../store/currentPosition'
import {
  overlayStore,
  setOverlayMode,
  setVersusColor,
  TOverlayMode,
} from '../../store/overlay'
import {
  getPaletteLink,
  paletteStore,
  setColor,
  setPalette,
  undo,
  redo,
} from '../../store/palette'
import { CopyButton } from '../CopyButton'
import { Button, ControlGroup } from '../inputs'
import { ChartSettings } from './ChartSettings'
import { ColorActions } from './ColorActions'
import { ColorEditor } from './ColorEditor'
import { PaletteSelect } from './PaletteSelect'
import { ThemeButton } from './ThemeButton'

const modes: TOverlayMode[] = ['APCA', 'WCAG', 'NONE', 'DELTA_E']

const texts = {
  APCA: 'APCA contrast',
  WCAG: 'WCAG contrast',
  NONE: 'Without overlay',
  DELTA_E: 'Delta E distance',
}

export function Header() {
  const palette = useStore(paletteStore)
  const overlay = useStore(overlayStore)
  const selected = useStore(selectedStore)

  return (
    <Wrapper>
      <ControlRow>
        <PaletteSelect />
        <CopyButton getContent={() => getPaletteLink(palette)}>
          <Link />
          Copy link
        </CopyButton>
      </ControlRow>

      <ControlRow>
        <ControlGroup>
          <Button onClick={undo}>
            <Undo />
            <SROnly>Undo</SROnly>
          </Button>
          <Button onClick={redo}>
            <Redo />
            <SROnly>Redo</SROnly>
          </Button>
        </ControlGroup>
      </ControlRow>

      <ControlRow>
        <ColorEditor
          color={selected.color}
          onChange={color => {
            let { l, c, h } = color
            setPalette(
              setColor(palette, [l, c, h], selected.hueId, selected.toneId)
            )
          }}
        />
        <ColorActions />
      </ControlRow>

      <ControlRow>
        <ControlGroup>
          <Button
            onClick={() => {
              // Cycle through modes
              const idx = modes.findIndex(mode => overlay.mode === mode) + 1
              setOverlayMode(modes[idx % modes.length])
            }}
          >
            {texts[overlay.mode]}
          </Button>
          {overlay.mode !== 'NONE' && (
            <Button
              onClick={() =>
                setVersusColor(
                  overlay.versus === 'selected' ? 'white' : 'selected'
                )
              }
            >
              vs. {overlay.versus}
            </Button>
          )}
        </ControlGroup>

        <ChartSettings />

        <ThemeButton />
        <Button as="a" href="https://github.com/ardov/huetone">
          <GitHub />
        </Button>
      </ControlRow>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  width: 100%;
  display: flex;
  padding: 16px;
  border-bottom: 1px solid var(--c-divider);
  justify-content: space-between;
`
const ControlRow = styled.main`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const SROnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`
